var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"700px","border":"0 none"},attrs:{"name":"iframe_name","id":"iframe_id","src":_vm.payment_url,"scrolling":"no","frameborder":"0"}}),_c('iframe')])
}
var staticRenderFns = []

export { render, staticRenderFns }